import BaseScenesPermissions from 'models/Permissions/BaseScenesPermissions'

class MultiquoteHomePermissions extends BaseScenesPermissions {}

export default MultiquoteHomePermissions
